import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontIcon from '@tekion/tekion-components/src/atoms/FontIcon';
import Loader from '../../../atoms/Loader';
import { isEmpty, renderIf, renderIfElse } from '../../../utils/helper';
import FullPageModal from '../../FullPageModal';
import { TODO_LIST_MODAL_TITLE } from '../todo.constants';
import styles from './TodoList.module.scss';
import Todo from '../Todo';
import EmptyTodoLogo from '../../../utils/svgs/EmptyTodo.svg';
import { Button } from 'antd/lib';
export default class TodoList extends Component {
  constructor() {
    super();
    this.renderFullPageModalHeader = () => {
      const {
        toggleShowTodo
      } = this.props;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.drawerHeader
      }, /*#__PURE__*/React.createElement("div", null, TODO_LIST_MODAL_TITLE), /*#__PURE__*/React.createElement(FontIcon, {
        onClick: () => toggleShowTodo(false)
      }, "tap-icon-close"));
    };
    this.addNewTodo = flag => {
      if (flag && this.addTodoRef.current) {
        this.addTodoRef.current.scrollIntoView();
      }
      this.setState({
        addTodoClicked: flag
      });
    };
    this.renderModalContent = () => {
      const {
        addTodoClicked
      } = this.state;
      const {
        todoLoading,
        userTodos,
        apiBaseUrl,
        addTodo
      } = this.props;
      return /*#__PURE__*/React.createElement(React.Fragment, null, todoLoading && /*#__PURE__*/React.createElement(Loader, {
        id: "todo-list-loader"
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.todoModalContent
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.todoList
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.addTodoRef
      }, addTodoClicked && /*#__PURE__*/React.createElement(Todo, {
        apiBaseUrl: apiBaseUrl,
        addNewTodo: this.addNewTodo,
        addTodo: addTodo
      })), renderIf(!isEmpty(userTodos), () => userTodos.map(event => /*#__PURE__*/React.createElement(Todo, {
        apiBaseUrl: apiBaseUrl,
        addNewTodo: this.addNewTodo,
        todo: event,
        addTodo: addTodo
      })))), renderIf(!todoLoading && isEmpty(userTodos) && !addTodoClicked, () => /*#__PURE__*/React.createElement("div", {
        className: styles.noData
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Empty todo logo",
        src: EmptyTodoLogo
      }), /*#__PURE__*/React.createElement("p", null, __('No To-do lists yet'))))));
    };
    this.renderModalFooter = () => {
      const {
        addTodoClicked
      } = this.state;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.drawerFooter
      }, renderIfElse(addTodoClicked, () => /*#__PURE__*/React.createElement(Button, {
        onClick: () => this.addNewTodo(false)
      }, __('Cancel')), () => /*#__PURE__*/React.createElement("div", {
        className: styles.iconWithBtn,
        role: "button",
        tabIndex: 0,
        onClick: () => this.addNewTodo(true)
      }, /*#__PURE__*/React.createElement(FontIcon, {
        className: styles.addIcon
      }, "icon-add"), /*#__PURE__*/React.createElement("a", {
        className: "".concat(styles.todoActionsBtnsAdd)
      }, __('Add Todo')))));
    };
    this.state = {
      addTodoClicked: false
    };
    this.addTodoRef = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    const {
      fetchUserTodos,
      apiBaseUrl
    } = this.props;
    fetchUserTodos(apiBaseUrl);
  }
  render() {
    const {
      toggleShowTodo
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.todoListWrapper
    }, /*#__PURE__*/React.createElement(FullPageModal, {
      footer: this.renderModalFooter(),
      header: this.renderFullPageModalHeader(),
      renderDetailedContent: this.renderModalContent,
      width: "60rem",
      onClose: () => toggleShowTodo(false)
    }));
  }
}
TodoList.propTypes = {
  todoActions: PropTypes.object.isRequired,
  loading: PropTypes.object.isRequired,
  toggleShowTodo: PropTypes.func.isRequired,
  userTodos: PropTypes.array.isRequired
};